import React from "react";
import {
  Card,
  CardContent,
  Typography,
  Grid2,
  Box,
  Skeleton,
  CardActionArea,
} from "@mui/material";
import { useSearchParams } from "react-router-dom";
import DevicesIcon from "@mui/icons-material/Devices";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";

const cards = [
  {
    label: "Total Devices",
    key: "total",
    filter: null,
    icon: <DevicesIcon sx={{ fontSize: 40 }} />,
    color: "primary.main",
  },
  {
    label: "Online",
    key: "online",
    filter: "ONLINE",
    icon: <CheckCircleIcon sx={{ fontSize: 40 }} />,
    color: "success.main",
  },
  {
    label: "Offline",
    key: "offline",
    filter: "OFFLINE",
    icon: <ErrorIcon sx={{ fontSize: 40 }} />,
    color: "error.main",
  },
];

const SummaryCards = ({ summary, isLoading }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const activeFilter = searchParams.get("status");

  return (
    <Grid2 container spacing={4} sx={{ mb: 4 }}>
      {cards.map((card) => (
        <Grid2 key={card.label} size={{ xs: 12, sm: 4 }}>
          <Card
            sx={{
              p: 2,
              ...(activeFilter === card.filter &&
                card.filter && {
                  outline: "2px solid",
                  outlineColor: card.color,
                }),
            }}
          >
            <CardActionArea
              onClick={() =>
                setSearchParams(
                  card.filter && activeFilter !== card.filter
                    ? { status: card.filter }
                    : {}
                )
              }
            >
              <CardContent>
                <Box
                  display="flex"
                  alignItems="center"
                  justifyContent="space-between"
                >
                  <Box>
                    <Typography variant="subtitle2" color="text.secondary">
                      {card.label}
                    </Typography>
                    <Typography variant="h3" fontWeight="bold">
                      {isLoading ? <Skeleton width={40} /> : summary[card.key]}
                    </Typography>
                  </Box>
                  <Box sx={{ color: card.color }}>{card.icon}</Box>
                </Box>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid2>
      ))}
    </Grid2>
  );
};

export default SummaryCards;
